export default __webpack_public_path__ + "static/media/declined.46e3de66.png";